var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_70967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5417 11.7185C21.2311 11.8011 20.952 11.9738 20.7396 12.215C20.5271 12.4562 20.391 12.7549 20.3484 13.0734C20.3057 13.392 20.3585 13.716 20.5 14.0045C20.6415 14.2931 20.8653 14.5332 21.1433 14.6945C21.4212 14.8558 21.7408 14.9311 22.0615 14.9108C22.3823 14.8905 22.6898 14.7756 22.9452 14.5806C23.2006 14.3855 23.3925 14.1191 23.4965 13.8151C23.6005 13.511 23.6121 13.1829 23.5296 12.8723C23.4749 12.666 23.3801 12.4725 23.2505 12.3029C23.121 12.1332 22.9593 11.9908 22.7747 11.8836C22.5901 11.7765 22.3862 11.7068 22.1746 11.6784C21.9631 11.6501 21.748 11.6637 21.5417 11.7185Z",
    fill: "url(#paint0_linear_47_70967)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1247 8.46855C15.8141 8.55107 15.535 8.72384 15.3226 8.965C15.1101 9.20617 14.974 9.5049 14.9314 9.82343C14.8887 10.142 14.9415 10.466 15.083 10.7545C15.2245 11.0431 15.4483 11.2832 15.7263 11.4445C16.0043 11.6058 16.3238 11.6811 16.6445 11.6608C16.9653 11.6405 17.2728 11.5256 17.5282 11.3306C17.7836 11.1355 17.9755 10.8691 18.0795 10.5651C18.1835 10.261 18.1951 9.93292 18.1126 9.6223C18.0579 9.416 17.9631 9.2225 17.8335 9.05286C17.704 8.88322 17.5423 8.74076 17.3577 8.63362C17.1731 8.52648 16.9692 8.45676 16.7576 8.42843C16.5461 8.40011 16.331 8.41374 16.1247 8.46855V8.46855Z",
    fill: "url(#paint1_linear_47_70967)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7077 11.7185C10.3971 11.8011 10.118 11.9738 9.90557 12.215C9.69315 12.4562 9.55702 12.7549 9.51437 13.0734C9.47173 13.392 9.52449 13.716 9.66598 14.0045C9.80748 14.2931 10.0314 14.5332 10.3093 14.6945C10.5873 14.8558 10.9068 14.9311 11.2275 14.9108C11.5483 14.8905 11.8558 14.7756 12.1112 14.5806C12.3666 14.3855 12.5585 14.1191 12.6625 13.8151C12.7665 13.511 12.7781 13.1829 12.6956 12.8723C12.6409 12.666 12.5461 12.4725 12.4165 12.3029C12.287 12.1332 12.1253 11.9908 11.9407 11.8836C11.7561 11.7765 11.5522 11.7068 11.3406 11.6784C11.1291 11.6501 10.914 11.6637 10.7077 11.7185Z",
    fill: "url(#paint2_linear_47_70967)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7077 18.2185C10.3971 18.3011 10.118 18.4738 9.90557 18.715C9.69315 18.9562 9.55702 19.2549 9.51437 19.5734C9.47173 19.892 9.52449 20.216 9.66598 20.5045C9.80748 20.7931 10.0314 21.0332 10.3093 21.1945C10.5873 21.3558 10.9068 21.4311 11.2275 21.4108C11.5483 21.3905 11.8558 21.2756 12.1112 21.0806C12.3666 20.8855 12.5585 20.6191 12.6625 20.3151C12.7665 20.011 12.7781 19.6829 12.6956 19.3723C12.6409 19.166 12.5461 18.9725 12.4165 18.8029C12.287 18.6332 12.1253 18.4908 11.9407 18.3836C11.7561 18.2765 11.5522 18.2068 11.3406 18.1784C11.1291 18.1501 10.914 18.1637 10.7077 18.2185V18.2185Z",
    fill: "url(#paint3_linear_47_70967)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5416 3.00785C14.7974 2.94721 13.0589 3.23837 11.4296 3.864C9.80039 4.48963 8.3138 5.4369 7.05849 6.64935C5.80318 7.8618 4.80484 9.3146 4.12301 10.9211C3.44118 12.5277 3.08981 14.255 3.08984 16.0003C3.09386 19.4469 4.46479 22.7511 6.90189 25.1882C9.33899 27.6253 12.6433 28.9963 16.0898 29.0003C16.456 29.0003 16.8157 28.9764 17.1732 28.9461C17.4444 28.9232 17.6972 28.7991 17.881 28.5983C18.0649 28.3976 18.1665 28.135 18.1655 27.8628L18.1308 23.9758C18.1221 23.2077 18.3424 22.4544 18.7638 21.8121C19.1851 21.1698 19.7883 20.6676 20.4964 20.3698C21.2044 20.0719 21.9852 19.9918 22.739 20.1397C23.4928 20.2877 24.1854 20.6569 24.7283 21.2003L24.8367 21.3086C25.0826 21.5566 25.3873 21.7384 25.7223 21.8371C26.0574 21.9358 26.412 21.9482 26.7531 21.873C27.0887 21.8026 27.4012 21.6489 27.6619 21.4261C27.9226 21.2033 28.123 20.9185 28.2448 20.5979C28.843 19.0274 29.1289 17.3553 29.0866 15.6753C28.9647 12.3754 27.6074 9.24187 25.2839 6.89564C22.9603 4.54942 19.8401 3.16181 16.5416 3.00785V3.00785ZM26.2721 19.6912L26.2569 19.676C25.4101 18.8306 24.331 18.2562 23.1568 18.0259C21.9827 17.7956 20.7665 17.9198 19.6631 18.3826C18.5597 18.8455 17.6189 19.6261 16.9604 20.6252C16.3019 21.6242 15.9555 22.7966 15.9653 23.9931L15.9913 26.8336C13.1181 26.8207 10.3677 25.6669 8.34522 23.6261C6.32271 21.5853 5.19375 18.8247 5.20668 15.9515C5.21961 13.0783 6.37337 10.328 8.41416 8.30547C10.4549 6.28297 13.2156 5.15401 16.0888 5.16694C16.2155 5.16694 16.3433 5.16694 16.4712 5.17344C19.2189 5.3025 21.8179 6.45907 23.7532 8.41397C25.6884 10.3689 26.8187 12.9794 26.9199 15.7284C26.9557 17.0756 26.737 18.4174 26.2753 19.6836L26.2721 19.6912Z",
    fill: "url(#paint4_linear_47_70967)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47_70967",
    x1: 20.334,
    y1: 15.2623,
    x2: 23.9586,
    y2: 14.4596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#7DA1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645919,
    stopColor: "#E16CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999152,
    stopColor: "#E65B8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_47_70967",
    x1: 14.917,
    y1: 12.0123,
    x2: 18.5416,
    y2: 11.2096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#7DA1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645919,
    stopColor: "#E16CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999152,
    stopColor: "#E65B8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_47_70967",
    x1: 9.5,
    y1: 15.2623,
    x2: 13.1246,
    y2: 14.4596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#7DA1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645919,
    stopColor: "#E16CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999152,
    stopColor: "#E65B8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_47_70967",
    x1: 9.5,
    y1: 21.7623,
    x2: 13.1246,
    y2: 20.9596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#7DA1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645919,
    stopColor: "#E16CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999152,
    stopColor: "#E65B8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_47_70967",
    x1: 3.08984,
    y1: 31.786,
    x2: 32.0879,
    y2: 25.3644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#7DA1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645919,
    stopColor: "#E16CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999152,
    stopColor: "#E65B8B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_70967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarColor);
export default __webpack_public_path__ + "static/media/avatar-color.629b37cdffad84a46b86325abd0e1a91.svg";
export { ForwardRef as ReactComponent };